import React = require("react");
import { WiseBook } from "../../../../custom_api/wise/types";
import { isSmallViewport } from "../../../util";
import { Link } from "../../library/link";

interface AdviceProps {
  advice: WiseBook[]
  state: 'loading' | 'loaded'
  urlFrom: (book: WiseBook) => string
  handlerFrom: (book: WiseBook) => () => void
}

export const anchorId = "advice-anchor"

export const Advice = (props: AdviceProps) => {
  const { advice, state, urlFrom, handlerFrom } = props
  return <ul className={`layout layout--grid-with-sidebar layout--${state}`}>
    {advice.map(b => <li className="layout__item" key={`advice-${b.id}`}>
      <Link
        url={urlFrom(b)}
        title={`${b.title} - ${b.author}`}
        handle={handlerFrom(b)}
        className={`bookresult bookcover bookcover--large`}
      >
        <div className="bookresult__cover bookcover__inner">
          <img className="bookresult__image bookcover__image" src={`${b.cover}size=195`} srcSet={`${b.cover}size=195 1x, ${b.cover}size=390 2x`} alt={`${b.title} - ${b.author}`} loading="lazy" width="195" height="310" />
        </div>
        <div className="bookresult__header">
          <span className="bookresult__title">{b.title}</span>
        </div>
        <div className="bookresult__author">{b.author}</div>
      </Link>
    </li>)}
  </ul>
}

export const AdviceScrollAnchor = () => <div id={anchorId} className="layout__anchor" aria-hidden="true" />

export const scrollAdviceIntoView = () => {
  const advice = document.getElementById(anchorId)
  if (!advice) return

  // On desktop, only scroll if top of advice is above the top of the viewport
  if (!isSmallViewport() && window.scrollY < advice.offsetTop) return

  advice.scrollIntoView({ behavior: "smooth" })
}